import { useMutation } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export type AdminTemplate = {
  id: string;
  displayName: string;
  templateType: string;
};

export type AdminMeetingNoteContent = {
  id: string;
  markdownContent: string | null;
  status: string | null;
};

type GenerateMeetingNoteResponse = {
  status: string;
  taskId: string | null;
  meetingNoteId: string | null;
  fileOwnerClientId: string | null;
};

type GenerateMeetingNotePayload = {
  destinationCompanyId: string;
  sourceCompanyId: string;
  templateId: string;
  clientId: string;
  dataUploadFileId: string;
  additionalInstructions?: string;
};

export const useGenerateMeetingNote = () => {
  const { mutateAsync, isPending, error, reset } = useMutation<
    { data: GenerateMeetingNoteResponse },
    Error,
    GenerateMeetingNotePayload
  >({
    mutationFn: ({ destinationCompanyId, ...body }) =>
      api.post<GenerateMeetingNoteResponse>(
        `admin/companies/${destinationCompanyId}/transcript-tester/meeting-note`,
        body,
      ),
  });

  return { generate: mutateAsync, isGenerating: isPending, error, reset };
};
